'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.evaluateQuery = exports.EvaluateQueryVisitor = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

// used for tests; use prepareQuery for live queries.
var evaluateQuery = exports.evaluateQuery = function () {
    var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(queryNode) {
        var visitor, walker;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        visitor = new EvaluateQueryVisitor(queryNode);
                        walker = new _QueryNodeWalker2.default();
                        _context2.next = 4;
                        return walker.walk(queryNode, visitor);

                    case 4:
                        return _context2.abrupt('return', visitor.queryNode.toQueryFragment());

                    case 5:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, this);
    }));

    return function evaluateQuery(_x2) {
        return _ref2.apply(this, arguments);
    };
}();

var _QueryNodeVisitor2 = require('./QueryNodeVisitor');

var _QueryNodeVisitor3 = _interopRequireDefault(_QueryNodeVisitor2);

var _QueryNodeWalker = require('./QueryNodeWalker');

var _QueryNodeWalker2 = _interopRequireDefault(_QueryNodeWalker);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var debug = require('debug')('@complion:query:engine:evaluateQuery');

var EvaluateQueryVisitor = exports.EvaluateQueryVisitor = function (_QueryNodeVisitor) {
    (0, _inherits3.default)(EvaluateQueryVisitor, _QueryNodeVisitor);

    function EvaluateQueryVisitor(rootNode) {
        (0, _classCallCheck3.default)(this, EvaluateQueryVisitor);

        var _this = (0, _possibleConstructorReturn3.default)(this, (EvaluateQueryVisitor.__proto__ || (0, _getPrototypeOf2.default)(EvaluateQueryVisitor)).call(this));

        _this.queryNode = rootNode;
        return _this;
    }

    (0, _createClass3.default)(EvaluateQueryVisitor, [{
        key: 'visitValueSet',
        value: function () {
            var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(context) {
                var value;
                return _regenerator2.default.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.prev = 0;
                                _context.next = 3;
                                return context.currentValueSet.toQueryFragment(context.appContext);

                            case 3:
                                value = _context.sent;

                                (0, _lodash.set)(this.queryNode, context.path, value);
                                _context.next = 10;
                                break;

                            case 7:
                                _context.prev = 7;
                                _context.t0 = _context['catch'](0);

                                debug(_context.t0);

                            case 10:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[0, 7]]);
            }));

            function visitValueSet(_x) {
                return _ref.apply(this, arguments);
            }

            return visitValueSet;
        }()
    }, {
        key: 'getFinalQuery',
        value: function getFinalQuery() {
            var query = this.queryNode.toQueryFragment();
            if (!query) {
                // if all conditions are removed due to optimaztion and
                // the final query is falsy, replace it with a valid
                // mongodb query that returns no documents
                query = { _id: { $in: [] } };
            }
            return query;
        }
    }]);
    return EvaluateQueryVisitor;
}(_QueryNodeVisitor3.default);

exports.default = EvaluateQueryVisitor;